export enum EFactorShowTypes {
    /** Плоский реестр */
    baseForm = 1,
    registry = 2,
}

export enum EFactorModulesFullUrl {
    /** Для реестра */
    input = 'factor/input/',
    inputRow = 'factor/input/row',
    /** Для плоского реестра */
    inputForm = 'factor/input/form/',
    moderationForm = 'factor/moderation/form',
    moderationRow = 'factor/moderation/row',
}

/** Список путей к контроллерам */
export enum EFactorControllerUrl {
    /** Для реестра */
    factorData = 'factor_data/factor_data',
    scheduler = 'factor/front_scheduler',
}

/**
 * Типы данных в факторе
 */
export enum EFactorFiledTypes {
    list = 'list',
    date = 'date',
    digit = 'digit',
    bool = 'bool',
    boolean = 'boolean',
    numerator = 'numerator',
    string = 'string',
    text = 'text',
    technicalProcess = 'technical_process',
    systemField = 'system_field',
    completeCondition = 'complete_condition',
    relation = 'relation',
    link = 'link',
    address = 'address',
    gallery = 'gallery',
    file = 'file',
    file_versions = 'file_versions',
    access = 'access',
}

/** Статус данных */
export enum EFactorDataStatuses {
    Draft = 'draft',
    Reject = 'reject',
    Moderation = 'moderation',
    PreModeration = 'pre-moderation',
    Approved = 'approved',
    UnsignedDocument = 'unsigned-document',
    Archived = 'archived',
    New = 'new',
}

/** Тип данных */
export enum EFactorDataTypes {
    Current = 'current',
    Reporting = 'reporting',
}

export enum EFactorDataGETActions {
    /** Получить срез на дату */
    getSlice = 'get_specific_item',
    interWindowEvent = 'inter_window_event',
}

export enum EFactorDataMaintenanceForm {
    solid = 'solid',
    period = 'period',
}

export enum EFactorDataSliceTypes {
    dataSliceParent = 'sliceParent',
}

/** Обновление срезов и актуальных данных */
export enum EChangeSliceData {
    /** Обновлять только редактируемые данные */
    current = 0,
    /** Обновлять актуальные данные при изменении среза */
    currentAndParent = 1,
    /** Обновлять срезы при изменении актуальных данных */
    parentAndChild = 3,
    /** Всегда обновлять срезы и актуальные данные */
    ALL = 4,
    /** Запрашивать решение у пользователя */
    userChoice = 5,
}

/** Тип дат */
export enum EFactorDateType {
    single,
    period,
}

/** Тип выравнивания в колонках */
export enum EColumnAlignment {
    left = 'left',
    right = 'right',
}

export enum EFactorDataPageEvent {
    afterSave,
}

/** Формат вывода дат в фильтре по реестрам */
export enum EFormatDateFields {
    Period = 'period',
    Single = 'single',
}
